import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { Box } from '@mui/system';
import Typography from '@mui/material/Typography';
import { IDENTIFICATION_METHOD_TOOLTIPS } from '../../../../constants/IdentificationMethodConstants';

import NRTagList from '../../../../components/NRTagList/NRTagList';

const getIdentifiedViaInfo = category => {
  if (!category || !IDENTIFICATION_METHOD_TOOLTIPS[category]) {
    return null;
  }
  return {
    tooltip: IDENTIFICATION_METHOD_TOOLTIPS[category],
    label: IDENTIFICATION_METHOD_TOOLTIPS[category].TITLE
  };
};

export const NRIdentificationFormatter = ({ value }) => {
  // Handle array of IdentifiedViaCategory enum values
  if (!value || !Array.isArray(value) || value.length === 0) {
    return null;
  }

  // Map each category to its tooltip info
  const identifiedViaItems = value
    .map(category => {
      const info = getIdentifiedViaInfo(category);
      return info ? { name: info.label, description: info.tooltip.CONTENT } : null;
    })
    .filter(item => item !== null); // Only include items with valid tooltips

  if (identifiedViaItems.length === 0) {
    return null;
  }

  return <NRTagList tags={identifiedViaItems} />;
};

export const NRIdentificationProvider = props => <DataTypeProvider formatterComponent={NRIdentificationFormatter} {...props} />;
